export const ScrollElementToTarget = (el, target, maxSize) => {
  if (target.getBoundingClientRect().bottom + maxSize >= window.innerHeight) {
    let combinedHeight = target.getBoundingClientRect().height + maxSize;
    let topCombine = el.scrollTop + target.getBoundingClientRect().top;
    let windowDifference = window.innerHeight - combinedHeight;
    if (el === window) {
      el.scrollBy(0, target.getBoundingClientRect().top - windowDifference);
    } else {
      el.scrollTop = topCombine - windowDifference;
    }
  }
}

/**
 * creates some helper methods for the window object
 * @param {object} windowObject - overrides the window object
 */
export const WindowHelperWrapper = (windowObject) => {
  windowObject = windowObject || (typeof window === 'undefined' ? {} : window);

  /**
   * sets the window's location to the passed URL
   * @param {string} destUrl
   */
  const open = (destUrl, target) => {
    if (windowObject.open) windowObject.open(destUrl, target);
  }

  /**
   * sets the window's location to the passed URL
   * @param {string} destUrl
   */
  const redirect = (destUrl) => {
    windowObject.location.href = destUrl;
  }

  /**
   * Gets the current window's pixel dimensions
   * @returns {object} { width, height }
   */
  const getDimensions = (element) => (
    element ?
      {
        width: element.clientWidth,
        height: element.clientHeight
      } :
      {
        width: windowObject.innerWidth || windowObject.document.body.clientWidth,
        height: windowObject.innerHeight || windowObject.document.body.clientHeight
      }
  )

  /**
   * Watches the window's resize event and returns the index of the matching
   * breakpoint
   * @param {array|number} breakpoints
   * @param {function({number})} onBreakpointChange whenever the breakpoint changes
   * @param {'x'|'y'} direction x or y
   * @returns {function} call to destroy the watcher
   */
  const watchBreakpoints = (points, onBreakpointChange, direction = 'x', element = null) => {
    function setBreakpoint() {
      const dimensions = getDimensions(element);
      const dimension = direction === 'y' ? dimensions.height : dimensions.width;
      let index;
      for (index = 0; index < count; index++) {
        const point = points[index];
        if (dimension < point) {
          break;
        }
      }
      if (index !== breakpoint) {
        breakpoint = index;
        onBreakpointChange(breakpoint);
      }
    }

    points = Array.isArray(points) ? points : [points];
    const count = points.length;
    let breakpoint;
    setBreakpoint();

    windowObject.addEventListener("resize", setBreakpoint);

    return () => {
      windowObject.removeEventListener("resize", setBreakpoint);
    }
  }

  return { open, redirect, getDimensions, watchBreakpoints };
}

/** WindowHelper methods using the window object */
export const WindowHelper = WindowHelperWrapper();
